export const realtorData = {
  email: 'propcm@unne.cl',
  phone:"992582381"
  // email: 'contacto@accionpanal.com',
};
